import React from 'react';
import PropTypes from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import QuantitySelector from 'components/commons/QuantitySelector';
import { getTotalPriceFromQuantity, getUnitPriceFromQuantity } from 'helpers/prices';
import './ItemTextil.scss';

const ItemTextil = ({
  item,
  colors,
  selectedColor,
  onColorSelect,
  quantity,
  onQuantityChange,
  onBuyClick,
  show,
  isFavorite,
  onToggleFavorite,
  cantMedidasMax = 0,
  renderInstallmentsBadge,
}) => {
  const handleBuy = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof onBuyClick === 'function') onBuyClick();
  };
  const imageSrc = selectedColor?.image_2 || selectedColor?.image_1 || item.image1;
  const slug = item.code || item.id;
  const productHref = `/producto/${slug}`;
  const isMobile = typeof window !== 'undefined' && window.innerWidth <= 768;

  const unitPrice = quantity > 0
  ? getUnitPriceFromQuantity(quantity, item.price, item?.stock_product_descriptions)
  : item.price;
  const totalPrice = getTotalPriceFromQuantity(quantity, item.price, item?.stock_product_descriptions);

  const renderMeasurePriceTable = () => {
    const seenNames = new Set();
  
    const stockDescriptions = (item.stock_product_descriptions || [])
      .filter(desc => {
        const name = desc?.stock_descriptions?.name;
        const isMeasure = desc?.stock_descriptions?.stock_category_id === 2;
        if (!isMeasure || !name || seenNames.has(name)) {
          return false;
        }
        seenNames.add(name);
        return true;
      });
  
    const measureTiers = stockDescriptions
      .filter((desc) => {
        const name = desc?.stock_descriptions?.name;
        return name && !isNaN(Number(name));
      })
      .map((desc) => ({
        min: parseFloat(desc.stock_descriptions.name),
        price: desc.price
      }))
      .sort((a, b) => a.min - b.min);
  
    const tiersWithLabels = [];

    let unitLabel;
    let unitLabelMobile;
    switch(item?.unit_type) {
      case 'kg':
        unitLabel = 'Kgs';
        unitLabelMobile = 'Kgs';
        break;
      case 'unidad':
        unitLabel = 'Unidades';
        unitLabelMobile = 'U';
        break;
      case 'metro':
        unitLabel = 'Metros';
        unitLabelMobile = 'Mts';
        break;
      default:
        unitLabel = 'Metros';
        unitLabelMobile = 'Mts';
    }
  
    if (measureTiers.length > 0) {
      if (measureTiers[0].min > 1) {
        tiersWithLabels.push({
          label: `Hasta ${measureTiers[0].min} ${unitLabel}`,
          price: item.price
        });
      }
  
      for (let i = 0; i < measureTiers.length; i++) {
        const tier = measureTiers[i];
        tiersWithLabels.push({
          label: isMobile ? `+${tier.min} ${unitLabelMobile}` : `+${tier.min} ${unitLabel}`,
          price: tier.price
        });
      }
    } else {
      tiersWithLabels.push({
        label: `Precio por ${unitLabel}`,
        price: item.price
      });
    }
  
    const fillerRows = (Number(cantMedidasMax) || 0) - tiersWithLabels.length + 1;
    for (let i = 0; i < fillerRows; i++) {
      tiersWithLabels.push({
        label: '',
        price: ''
      });
    }
  
    return (
      <div className="pt-price-table">
        {tiersWithLabels.map((tier, i) => (
          <div key={i} className="pt-price-row">
            <span className="pt-price-label">{tier.label}</span>
            <span className="pt-price-value">
              {tier.price !== '' ? `$${tier.price?.toLocaleString('de-DE')}` : ''}
            </span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="it-card">
      {item.sale > 0 && (
        <span className="it-badge">-{Math.round(100 - (item.sale / item.price) * 100)}% OFF</span>
      )}

      <Link to={productHref} className="it-image">
        <img src={imageSrc} alt={item.name} />
        <span className="it-add">Ver Detalles</span>
      </Link>

      <div className="it-body">
        <h3 className="it-title">
          <Link to={productHref}>{item.name}</Link>
          <div className="product-badges">
            {renderInstallmentsBadge && renderInstallmentsBadge()}
          </div>
        </h3>


        {renderMeasurePriceTable()}
        <div className="it-qty">
          <QuantitySelector
            limit={item.stock}
            quantity={quantity}
            onQuantityChange={onQuantityChange}
            show={show}
            isTextil={true}
            unit_type={item?.unit_type}
          />
        </div>

        <button type="button" className="api-buy-btn" onClick={handleBuy}>
          Comprar
        </button>

        <div className="it-total">
          <small>{quantity} × ${unitPrice.toLocaleString('de-DE')}</small>
          <strong>${totalPrice.toLocaleString('de-DE')}</strong>
        </div>


        {/* <div className="it-actions">
          <Link to='/carrito' className="it-cart" onClick={(e) => { e.stopPropagation(); }}>
            <ShoppingCartIcon />
          </Link>
        </div> */}
      </div>
    </div>
  );
};

ItemTextil.propTypes = {
  renderInstallmentsBadge: PropTypes.func,
  onBuyClick: PropTypes.func,
};

export default ItemTextil;
